'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { createPortal } from 'react-dom';
import { Transition } from 'react-transition-group';
import { InternalProvider, useTrapFocus, useCombinedRefs, useIsBrowser, useComponentDeprecation } from '../../util';
import { ModalActions, ModalActionsLong, ModalBackground, ModalContainer, ModalInner, FadeTransition } from './elements';
import { ModalDismissButton } from './ModalDismissButton';
import { IllustrationModal, IconModal, DefaultModal } from './variants';
import { Button } from '../Button';
const renderModalVariant = ({
  modalVariant,
  title,
  titleFontSize,
  subTitle,
  iconSrc,
  stickyHeader
}, children) => {
  switch (modalVariant) {
    case 'illustration':
      return /*#__PURE__*/React.createElement(IllustrationModal, {
        title: title,
        titleFontSize: titleFontSize,
        subTitle: subTitle,
        iconSrc: iconSrc,
        stickyHeader: stickyHeader
      }, children);
    case 'icon':
      return /*#__PURE__*/React.createElement(IconModal, {
        title: title,
        titleFontSize: titleFontSize,
        subTitle: subTitle,
        iconSrc: iconSrc,
        stickyHeader: stickyHeader
      }, children);
    default:
      return /*#__PURE__*/React.createElement(DefaultModal, {
        title: title,
        titleFontSize: titleFontSize,
        subTitle: subTitle,
        stickyHeader: stickyHeader
      }, children);
  }
};

/**
 * @deprecated
 */
export const Modal = /*#__PURE__*/React.forwardRef(({
  isOpen,
  showXButton = true,
  title = '',
  titleFontSize,
  subTitle = '',
  primaryButtonLabel = '',
  secondaryButtonLabel = '',
  primaryButtonDisabled = false,
  secondaryButtonDisabled = false,
  modalButtonType = 'default',
  modalVariant = 'icon',
  iconSrc = '',
  dismissButtonClassName = 'string',
  onCloseClick,
  onPrimaryClick,
  onSecondaryClick,
  stickyHeader = true,
  dataTestId,
  width,
  children,
  portalContainer,
  ...rest
}, fRef) => {
  useComponentDeprecation({
    name: 'Modal',
    alternative: '@soluto-private/aui-react-modal',
    version: '5'
  });
  const innerRef = React.useRef();
  const combinedRef = useCombinedRefs(fRef, innerRef);
  const modalInnerProps = {
    ...rest
  };
  useTrapFocus(innerRef);
  const isBrowser = useIsBrowser();
  return isBrowser ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(Transition, {
    in: isOpen,
    timeout: 200,
    "data-aui": "modal"
  }, transitionStatus => /*#__PURE__*/React.createElement(FadeTransition, {
    transitionStatus: transitionStatus
  }, /*#__PURE__*/React.createElement(ModalBackground, null), /*#__PURE__*/React.createElement(ModalContainer, {
    ref: combinedRef,
    onClick: onCloseClick
  }, /*#__PURE__*/React.createElement(ModalInner, _extends({
    "aria-labelledby": "dialog-title",
    "aria-describedby": "dialog-content",
    "aria-modal": "true",
    role: "dialog",
    width: width,
    onClick: evt => evt.stopPropagation(),
    "data-testid": dataTestId
  }, modalInnerProps), showXButton && /*#__PURE__*/React.createElement(ModalDismissButton, {
    className: dismissButtonClassName,
    onClick: onCloseClick,
    "data-testid": "ModalDismissButton",
    actionButtonPresent: !!primaryButtonLabel || !!secondaryButtonLabel
  }), renderModalVariant({
    modalVariant,
    title,
    titleFontSize,
    subTitle,
    iconSrc,
    stickyHeader
  }, children), modalButtonType == 'default' && (primaryButtonLabel || secondaryButtonLabel) && /*#__PURE__*/React.createElement(ModalActions, null, secondaryButtonLabel && /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    variant: "outline",
    onClick: onSecondaryClick,
    "data-testid": "SecondaryModalButton",
    disabled: secondaryButtonDisabled
  }, secondaryButtonLabel), primaryButtonLabel && /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    variant: "default",
    onClick: onPrimaryClick,
    "data-testid": "PrimaryModalButton",
    disabled: primaryButtonDisabled
  }, primaryButtonLabel)), modalButtonType == 'long' && (primaryButtonLabel || secondaryButtonLabel) && /*#__PURE__*/React.createElement(ModalActionsLong, null, primaryButtonLabel && /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    variant: "default",
    onClick: onPrimaryClick,
    "data-testid": "PrimaryModalButton",
    disabled: primaryButtonDisabled
  }, primaryButtonLabel), secondaryButtonLabel && /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    variant: "flat",
    onClick: onSecondaryClick,
    "data-testid": "SecondaryModalButton",
    disabled: secondaryButtonDisabled
  }, secondaryButtonLabel))))))), portalContainer || document.body) : null;
});